
import { Vue } from "vue-class-component";
export default class DialogPaymentLayoutButton extends Vue {}
